import { render, staticRenderFns } from "./AffiliatePayment.vue?vue&type=template&id=69688c63"
import script from "./AffiliatePayment.vue?vue&type=script&lang=ts"
export * from "./AffiliatePayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports